import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { TranslateService } from "@ngx-translate/core";
import { SearchHeaderService } from "../../services/SsearchHeader.service";

import moment from "moment";
import { PatientNotesDialogComponent } from "../patient-notes-dialog/patient-notes-dialog.component";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { removeSpaces } from "../../helper/helper.service";
import { mandatoryFields } from "../../properties/field-mandatory-properties";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { patientGetDataservice } from "../../services/SpatientGetData.service";
import { MasterUrlService } from "../../services/SmasterUrl.service";
import { CameraDialogComponent } from "../../shared/camera-dialog/camera-dialog.component";
import { RegsuccessDialogComponent } from "../../shared/regsuccess-dialog/regsuccess-dialog.component";
import {
  OPD_REPORT_NAME,
  OPD_REPORT_TYPE,
} from "../../properties/opd-report-properties";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import {
  printObject,
  priviousEncounterObject,
} from "../../interface/IerRegistration";
import { mandatoryFieldsService } from "../../services/SmandatoryFields.service";
import { statisGlApprovalType } from "../../enums/encounter-status.enum";
import { HttpClient } from "@angular/common/http";
import { PatientRegistrationService } from "../../services/Spatient-registration.service";
import { MASTERSSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/master-service";
import { MasterKeys, MasterSubMenus } from "projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants";
import { STATICCODESERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/static-code-service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { ConfirmDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dialog/confirm-dialog.component";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { InfoDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/info-dialog/info-dialog.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { Langauge, MasterMenus } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { BirthPlaceList } from "projects/lib/medcare-core-lib/src/lib/regproperties/birth-place";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { PatientEncounterPayer, PatientRegistration } from "projects/lib/medcare-core-lib/src/lib/services/RegistationModel";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { UtilsService } from "projects/lib/medcare-core-lib/src/lib/services/utils.service";
import { MyKadData } from "projects/lib/medcare-core-lib/src/lib/regmodels/MmyKadData";
import { OPD_CONST } from "projects/lib/medcare-core-lib/src/lib/regproperties/opd-static-properties";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Identification } from "projects/lib/medcare-core-lib/src/lib/regmodels/MpatientRegistration";

@Component({
  selector: "app-emergency-registration",
  templateUrl: "./emergency-registration.component.html",
  styleUrls: ["./emergency-registration.component.scss"],
  providers: [DatePipe],
})
export class EmergencyRegistrationComponent implements OnInit, OnDestroy {
  private subscriptionList = new Subscription();
  patientId: string = "";
  patientForm: boolean = true;
  patientImage: string = "";
  isDeceased: boolean = false;
  printPayload: printObject;
  selectedPatient: any;
  searchCriteria: any = null;
  patientList: [] = [];
  refreshTime: string = "";
  hidePatientSearch = false;
  isBothAddressSame: boolean = false;
  patientInfoDisplay: string = "";
  previousEncounterList: any[] = [];
  dataSourceEncounters = new MatTableDataSource<priviousEncounterObject>([]);
  unitName: string;
  isRegistered: boolean = false;
  username: string;
  userId: number;
  usermasterid: number;
  patientTRN: string = "";
  isDisabled: boolean = false;

  isAdmissionRequest: boolean = false;

  dipartmentSearch: FormControl = new FormControl();
  departmentFilterLists:any[]=[];
  departmentLists:any[]=[];

  payerTypeSearch: FormControl = new FormControl();
  payerSearch: FormControl = new FormControl();
  tariffSearch: FormControl = new FormControl();
  contractCodeSearch: FormControl = new FormControl();
  associatedCompanySearch: FormControl = new FormControl();

  displayedColumnsEncounters: string[] = OPD_CONST.displayColumnEncounters;

  primaryIdList: any[] = [];
  primaryIdFilteredList: any[]=[];
  secondaryIdList: any[] = [];
  secondaryIdFilteredList: any[] = [];

  appointmentReference: {
    appointmentId: string;
    tempPatientId: string;
    trnNumber: string;
    doctorCode: string;
    departmentCode: string;
  } = {
    appointmentId: "",
    tempPatientId: "",
    trnNumber: "",
    doctorCode: "",
    departmentCode: "",
  };

  genderValue: any = null;
  identifierTypeValue: [] = null;
  titleValue: [] = null;

  encounterTypeValue: [] = null;
  departmentValue: [] = null;
  departmentValues:any=null;
  doctorValue: [] = null;

  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();
  minDate = moment().add("year", -200);
  maxDate = new Date(this.year, this.month, this.day);
  maxExpiry = new Date(this.year + 20, this.month, this.day);
  primaryIdRegex: string = OPD_CONST.primaryIdRegix;
  isexpiryDate: boolean = false;
  isValid: boolean = false;
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "0",
    months: "0",
    days: "0",
  };
  masterAPI: any = MASTERSSERVICES;
  mandatoryField: any = mandatoryFields;
  unitCode: string;
  formRegistration: FormGroup;

  //--End Registration Details---//

  formEncounter: FormGroup;
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  isDepartment: boolean = true;
  isPassport: boolean = false;
  doctorSearch: FormControl = new FormControl();
  doctorFilteredList: any = [];
  internalNotesList: [] = [];
  previousInternalNotes: [] = [];
  internotesEncounterid: number;
  internotesEncounterNo:number;
  selected: string;
  encounternumber: string = "";
  minIdentificationLength:number=0;
  maxIdentificationLength:number=20;
  
  //-----Encounter Details End Here-----//

  //payer Details//
  displayedColumnsPayers: string[] = OPD_CONST.displayColumnPayers;
  dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>([]);
  payerList: any[] = [];
  payerTypeList: any[] = [];
  tariffList: any[] = [];
  contractList: [] = [];
  associatedCompanyList: [] = [];
  glTypeList: [] = [];

  payerTypeFilteredList: any;
  payerFilteredList: any;
  tariffFilteredList: any;
  contractCodeList: any;
  associatedCompanyCodeList: any;
  docList: any;
  ////---payer Ends Here---//
  admissionStatus: boolean;
  medicalReport: boolean;
  doctorValueappointment: any;
  mandatorykeys: mandatoryFieldsService = new mandatoryFieldsService();
  appointmentData: null;
  mrdDepartment:string='';
  opdSpeciality: any;
  multiLangDoctorList: any[] = [];
  isSelectedPatient: boolean=false;
  isFirstPayerPriority: boolean;
  existingPayerList: any;
  contractValue: any=[];
  isVip: boolean = false;
  isNoteVisible?:string
  mobileNoMax: number= 14;
  mobileNoMin: number= 8;
  isDefaultDeposit: boolean = false;
  defaultDeposit: string = "";

  private socket: WebSocket;
  identificationTypeList: any[];
  genderList: any[] = [];
  raceList: any[] = [];
  religionList: any[] = [];
  orgCode: string='';
  defaultCountry:string='';
  countryCode: string;
  countryCodeLists: any[]=[];
  showFields:boolean = true;
  isDisabledName: boolean = false;
  output: string;
  selectedPrimaryId: string;
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subDistrictPrimaryList: any[] = [];
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;
  countryValue: any =  null;
  isPrimaryNoEditable:boolean=false;
  langaugeValue:string;
  defaultIdentification: string='';
  primaryIdCode: any;
  primaryIdNewValue: any;
   displayedColumns: string[] = OPD_CONST.identificationTable;
   identificationList = new MatTableDataSource<Identification>([]);
   @ViewChild(MatTable) tableidentification!: MatTable<Identification>;
   selectedPatientIdentificationList:Identification[]=[];
  primaryIdentifierListModified: boolean;
  secondaryIdentifierListModified: boolean;
  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private searchService: SearchService,
    private appBaseService: AppBaseService,
    public translate: TranslateService,
    public authService: AuthService,
    private patientService: PatientService,
    public applicationConfig: ApplicationConfigService,
    private patientRegService: PatientRegistrationService,
    private langService: MultiLanguageService,
    public searchHead: SearchHeaderService,
    public generalApiService: GeneralUrlService,
    public masterApiService: MasterUrlService,
    public patientDataService: patientGetDataservice,
    private utilsService: UtilsService,
    private datepipe: DatePipe,
    private http: HttpClient,
    private thConvertService:thEnConverterService,
    private cdr: ChangeDetectorRef
  ) {
    this.getPrimaryIdList();
  }

  /**
   *load method
   *
   * @memberof SamplePatientRegistrationComponent
   */
  ngOnInit() {
    this.addEmptyIdentificationEntry("P");
    this.formRegistration= this.formBuilder.group({
      id: [""],
      isVip: [false],
      isNewborn: [false],
      active:[false],
      mrn: [""],
      primaryId: [""],
      primaryNumber: [null, [removeSpaces]],
      expiryDate: [""],
      issuedCountryPrimary: [""],
      secondaryId: [""],
      secondaryNumber: [""],
      issuedCountrySecondary: [""],
      faculty: [""],
      firstName: [null, [removeSpaces]],
      aliasName: [{value: '', disabled: true}, [removeSpaces]],
      isKnown :[true],
      dateOfBirth: [""],
      realdob: [false],
      prefix: [""],
      gender: [""],
      race: [""],
      nation: [""],
      patientCategory: [""],
      martial: [""],
      occupation: [""],
      preferredLanguage: [""],
      bloodGroup: [""],
      religion: [""],
      isDeceased: [false],
      isBlock: [false],
      isCtos: [false],
      sourceType: [""],
      patientNotes: [null, [removeSpaces]],
      addressPrimary: [null, [removeSpaces]],
      countryPrimary: [""],
      statePrimary: [""],
      cityPrimary: [""],
      subDistrictPrimary: [""],
      homeContact: [""],
      personalFax: [""],
      education: [""],
      birthplace: [""],
      workFax: [""],
      motherName: [""],
      ethnic: [""],
      mobileNumber: [""],
      addressSecondary: [null, [removeSpaces]],
      countrySecondary: [""],
      stateSecondary: [""],
      citySecondary: [""],
      subDistrictSecondary: [""],
      workContact: [""],
      contactRelation: [""],
      pincodePrimary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      pincodeSecondary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      emailId: [
        "",
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"),
      ],
      birthTime: [""],
      countryCodemobile: [""],
      secondaryExpirydate: [""],
    });
  
    //--End Registration Details---//
  
    this.formEncounter = this.formBuilder.group({
      visitToDepartment: [""],
      encounterType: [""],
      department: ["", Validators.required],
      doctor: ["", Validators.required],
      clinic: [""],
      cashCounter: [""],
      remarks: [null],
      queueNumber: [""],
      referralType: [""],
      referral: [""],
      reportType: [""],
      reportReason: [""],
      patientCategory: [""],
      practiceNotes: [null],
      visittype: ["ER"],
      referralRemarks: [null, [removeSpaces]],
      reportRemarks: [null, [removeSpaces]],
    });
    this.checkFields(true);
    this.getCountryCode();
    this.getPreviousPayerList();
    // let patientEncounterPayer = new PatientEncounterPayer();
    // patientEncounterPayer.isSelf = true;
    // this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>([
    //   patientEncounterPayer,
    // ]);
    this.langaugeValue=localStorage.getItem("lan");
    this.fillDropDownLists();
    this.getScreenConfigurations();
    this.initSearchFilter();
    // this.getOrgAppConfigList();
    this.searchOnChanges();
    this.getUnitData();
    this.initMyKadCardReader();

    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
    });

    this.getFirstName();
  }
  getFirstName(){
    var date = new Date();
    var day = date.getDate();
    var hours = ("0" + date.getHours()).slice(-2);
    var minutes = ("0" + date.getMinutes()).slice(-2);
    var seconds = ("0" + date.getSeconds()).slice(-2);
    let name= "UNKNOWN"+"-"+day+":"+hours+":"+minutes+":"+seconds;
    this.formRegistration.patchValue({
      firstName: name,
    }); 
  }

  /**
   *get user info details
   *
   * @memberof PatientRegistrationComponent
   */
  getUserInfo() {
    this.authService.getUserInfo().then((value: any) => {
      this.username = value.userName;
      this.userId = value.userId;
      this.usermasterid = value.user_code;
    });
  }

  /**
   * To get unit data
   * @memberof SamplePatientRegistrationComponent
   */
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      this.getAppConfigurationList();
      this.getOrgAppConfigList();
    });
  }

  /**
   *Fill DropDown List
   *
   * @memberof SamplePatientRegistrationComponent
   */
  fillDropDownLists() {
    this.getCountryList();
    this.getPayerList();
    this.getPayerTypeList();
    this.getContractListData();
    this.getTariffmaster();
    this.getAssociatedCompanyList();
    this.getGLTypeList();  
    this.getDoctorList(null); 
    this.getdepartment();
  }

  getdepartment() {
    this.masterApiService
      .getTypeMaster(this.masterAPI.DEPT_GET_DEPT_BY_UNIT)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.departmentLists = data;
        this.departmentFilterLists=this.departmentLists
        this.getAppConfigList();
      });
  }

  /**
   *getpatient search by id
   *
   * @param {*} patientId
   * @memberof SamplePatientRegistrationComponent
   */
  getpatientbyId(patientId) {
    let reqPayload =
      "identificationId=&name=&mrn=" +
      patientId +
      "&gender=&unitCode=&city=&identificationType=&frDate=&toDate=&id=&mobile=&birthDate=&offset=&size=&pincode=&country=&state=";
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_PATIENT_SEARCH + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any[]) => {
        let pateintData = this.patientDataService.displayList(res);
        this.getPatientData(pateintData[0]);
      });
  }
 /**
   * application configuration source
   */

  getAppConfigList() {
    let mrdConfig: any;
    this.applicationConfig
      .getModuleConfiguration(MasterMenus.OPD, "",true)
      .subscribe((res) => {
        if (res) {
          mrdConfig = res;
          mrdConfig.forEach((element) => {
            // if (element.key == "DepartmentMaster") {
            //   this.departmentValues =this.departmentLists.find(e=>e.code== element.valueList[0].code);
            //   this.getDoctorList(this.departmentValues.code);
            // }
            if (element.key == MasterKeys.firstPayerPriorityRequired){
              if (element.valueList.length > 0) {
                this.isFirstPayerPriority = element.valueList[0].code=="true"?true:false;
              }
            }
            if (element.key == MasterKeys.emergencyDoctor){
              let value = this.docList.find(i=>i.code == element.valueList[0].code)
              if (element?.valueList?.length > 0) {
                setTimeout(() => {
                  this.formEncounter.patchValue({
                    doctor: value ? value.code : "",
                  });
                },1000);
                  this.getSpeciality(element.valueList[0].code)
              }
            }
            if (element.key == MasterKeys.isDefaultDepositRequired){
              if (element.valueList.length > 0) {
                this.isDefaultDeposit = element.valueList[0].code=="true"?true:false;
              }
            }
            if (element.key == MasterKeys.isDefaultDepositRequired){
              if (element.valueList.length > 0) {
                this.isDefaultDeposit = element.valueList[0].code=="true"?true:false;
              }
            }
           });
        }
      });
  }
  getAppConfigurationList() {
    let mrdConfig: any;
      this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
      this.appBaseService
        .getResource( "appConfiguration/findConfigByModule?unitCode="+this.unitCode+
          "&orgCode="+this.orgCode+"&moduleName="
          +OPD_CONST.patientManagement+"&keyName=")
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
        if (res) {
          mrdConfig = res.keys;
          mrdConfig.forEach((element) => {
          
            if (element.key == MasterKeys.DefaultCountryCode){
              if (element.valueList.length > 0) {
                this.defaultCountry = element.valueList[0]?.code;
                let code = this.countryCodeLists.filter(i=>i.code ==element.valueList[0]?.code)
                this.countryCode=element.valueList[0].code;
                this.setPatternToMobileNumber(code[0]);
              }
            }
          });
        }
      });
  }
  getCountryCode() {
    this.masterApiService
      .getTypeMaster(this.masterAPI.COUNTRY_CODE_MASTER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryCodeLists = data;
      });
  }
  /*
  Screen configuration source
  */
  getScreenConfigurations() {
    this.subscriptionList.add(
      this.applicationConfig
        .getScreenConfiguration("OPD",MasterSubMenus.ERRegistration)
        .subscribe((config:any) => {
          if (config) {
            this.mandatorykeys.setMandatoryFormValues(config, mandatoryFields);
          }
        })
    );
  }

  getOrgAppConfigList() {
    let appConfig: any;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res) {
          appConfig = res.keys;
          appConfig.forEach((element) => {
            if (element.key == MasterKeys.primaryIdentification){
              if (element.valueList?.length > 0 && element.valueList[0]?.code) {
                let value = this.primaryIdFilteredList.find(i=>i.code == element.valueList[0]?.code);
                
              this.formRegistration.patchValue({
                primaryId: value.code});
                this.cdr.detectChanges();
                this.identificationList.data[0].idType=value?.code;
                this.mandatoryField.identificationType=true;
                this.mandatoryField.identificationNo=true;
                this.primaryIdentificationOnChange(value ,false)
            }
          }
        });
        } 
      });
  }           

  /**
   *It is the source of doctor data
   *
   * @param {*} departmentCode
   * @memberof PatientRegistrationComponent
   */
   getDoctorList(departmentCode) {
      let payload = {
        limit: 0,
        unitCode: this.unitCode,
        departmentCode: departmentCode ? departmentCode : null,
        typeCodeList: ["DR"],
      };
      this.masterApiService
        .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST, payload)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          let list = [];
          let letmultilangdoclist = [];
          if (
            data &&
            data.payload &&
            data.payload.employeeResponseList &&
            data.payload.employeeResponseList.length > 0
          ) {
            data.payload.employeeResponseList.forEach((element) => {
              list.push({
                id: element.id,
                code: element.code,
                desc: element.desc,
              });
              letmultilangdoclist.push(element);
              if (this.previousEncounterList.length > 0)
                this.formEncounter.controls["doctor"].setValue(this.doctorValue);
            });
          }
          this.multiLangDoctorList = letmultilangdoclist;
          this.doctorFilteredList = list;
          this.docList = list;
        });
  }

  /**
   *Destroy mehtod
   *
   * @memberof SamplePatientRegistrationComponent
   */
  ngOnDestroy() {
    this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
    this.socket.close();
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  initMyKadCardReader() {
    try {
      this.getMyKadMasters();
      this.socket = new WebSocket("ws://localhost:8888");

      this.socket.onopen = () => {
        console.log("WebSocket connection established.");
      };

      this.socket.onmessage = (event) => {
        console.log("Received message:", event.data);
        this.loadMyKadData(event);
      };

      this.socket.onclose = (event) => {
        console.log("WebSocket connection closed:", event);
      };

      this.socket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    } catch (e) {}
  }

  /**
   *
   *
   * @param {*} event
   * @memberof EmergencyRegistrationComponent
   */
  loadMyKadData(event) {
    let myKadData: MyKadData = JSON.parse(event.data);
    // let myKadData: MyKadData = event;
    if (myKadData.Name) {
      const GenderCode = this.patientRegService.getCodeBySystemCode(
        this.genderList,
        myKadData.Gender ? myKadData.Gender : ""
      );

      const cardType = (myKadData.CardType && myKadData.CardType == STATICCODESERVICE.IDENTIFICATION_TYPE_MYKAD)
        ? STATICCODESERVICE.IDENTIFICATION_TYPE_MYKAD
        : STATICCODESERVICE.IDENTIFICATION_TYPE_MYKID

      const IdType = this.patientRegService.getCodeByStaticCode(
        this.identificationTypeList,
        cardType
      );

      const dob = moment(myKadData.BirthDate, "DD/MM/YYYY hh:mm:ss aa").format(
        "YYYY-MM-DD"
      );

      this.genderValue = GenderCode;

      this.formRegistration.patchValue({
        id: "",
        mrn: "",
        firstName: myKadData.Name,
        primaryId: IdType,
        expiryDate: "",
        primaryNumber: myKadData.ICNo,
        dateOfBirth: new Date(dob),
        gender: GenderCode,
        addressPrimary: myKadData.Address1 + " " + myKadData.Address2 + " " + myKadData.Address3,
        pincodePrimary: myKadData.Postcode
      });

      if (myKadData.PhotoBase64)
        this.patientImage = "data:image/jpeg;base64," + myKadData.PhotoBase64;
      else this.patientImage = "";

      this.primaryNumberOnKeyUp(myKadData.ICNo);
      this.formRegistration.updateValueAndValidity();
    }
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  getMyKadMasters() {
    this.getIdentificationTypeMaster();
    this.getGenderMaster();
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  getGenderMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_GENDER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.genderList = data;
      });
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  getIdentificationTypeMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.identificationTypeList = data;
      });
  }

  /**
   * get speciality
   * @param event 
   */
  getSpeciality(value){
    if(value){
      this.masterApiService
        .postTypeMaster(OPD_API_URL.GET_SPECIALITY_BY_DOCTOR+value, '')
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          if(data.payload){
            // this.departmentFilterLists =data.payload;
            // this.departmentValues= data.payload[0];
            this.departmentValues = this.departmentFilterLists.find((element) => element.code === data.payload[0].code);
          }
        })
    }

  }

  /**
   *Search On changes
   *
   * @memberof SamplePatientRegistrationComponent
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.doctorSearch.valueChanges.subscribe((value) => {
        this.doctorFilteredList = this.docList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.formRegistration.controls["dateOfBirth"].valueChanges.subscribe(
        (val) => {
          this.patientAge = this.patientService.calculateAge(val,"formatted");
        }
      )
    );
    this.subscriptionList.add(
      this.dipartmentSearch.valueChanges.subscribe((value) => {
        this.departmentFilterLists = this.departmentLists.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.formEncounter.controls["visitToDepartment"].valueChanges.subscribe(
        (isVisitToDepartment) => {
          let doctorControl = this.formEncounter.controls["doctor"];
          this.formEncounter.controls["doctor"].setValue("");
          if (isVisitToDepartment) {
            doctorControl.clearValidators();
            this.isDepartment = false;
            doctorControl.disable();

          } else {
            doctorControl.enable();
            doctorControl.setValidators([Validators.required]);
            this.isDepartment = true;
          }
          doctorControl.updateValueAndValidity();
        }
      )
    );
    this.subscriptionList.add(
      this.payerTypeSearch.valueChanges.subscribe((value) => {
        this.payerTypeList = this.payerTypeFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.payerSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
        element.payerList = element.payerFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    })
    );
    this.subscriptionList.add(
      this.contractCodeSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
          element.contractList = element.contractCodeList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        });
      })
    );
    this.subscriptionList.add(
      this.associatedCompanySearch.valueChanges.subscribe((value) => {
        this.associatedCompanyList = this.associatedCompanyCodeList.filter(
          (i) => i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.tariffSearch.valueChanges.subscribe((value) => {
        this.tariffList = this.tariffFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );

    
  }

  
   /**
   *validate doctor
   *
   * @memberof EmergencyRegistrationComponent
   */
   validationOnDoctor() {
    
    let departmentCode = this.formEncounter.controls["department"].value;
    let doctorCode = this.formEncounter.controls["doctor"].value;
    if (this.patientId && departmentCode) {
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_DUPLICATE_ENCOUNTER +
            departmentCode.code +
            "&doctorCode=" +
            doctorCode +
            "&patientId=" +
            this.patientId
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((response: any) => {
          if (response) {
            this.snackBar.open(
              this.langService.get("CommonAppoinment.warning"),
              this.langService.get("CommonAppoinment.duplicateEncouter") + "",
              {
                duration: 1000,
              }
            );
          }
        });
    }
  }


  /**
   *upload image
   *
   * @memberof SamplePatientRegistrationComponent
   */
  uploadImageDialog(): void {
    const dialogRef = this.dialog.open(CameraDialogComponent, {
      width: "400px",
      data: { name: "" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        try {
          if (result.res == "yes") {
            this.patientImage = result.picdata;
          } else {
            this.patientImage = "";
          }
        } catch (e) {}
      })
    );
  }
  /**
   *select patient Data
   *
   * @param {*} patient
   * @memberof SamplePatientRe
   * 
   * gistrationComponent
   */
  patientOnSelect(patient) {
    this.isSelectedPatient=true;
    this.getPatientStatus(patient);
  }
  getPatientStatus(patient) {
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.PATIENT_STATUS_FILTER + patient.id)
      .subscribe((res) => {
        this.admissionStatus = res.isAdmitted;
        if (res.isAdmitted == true) {
          
          if (res.validationMsg) {
            this.snackBar.open(
            this.langService.get("adt.Selectedpatient"),
            this.langService.get("dialogs.info"),
            {
              duration: 3000,
            });
          }
           this.formRegistration.reset();
           this.formEncounter.reset();
        } else {
          if (patient.id) {
            this.formRegistration.get('isKnown').setValue(false);
            this.getPatientData(patient);            
            this.isRegistered = true;
            // this.isDisabledName = true;
            this.isDisabledName = false;
          }
        }
      });
  }

  /**
   *get patient data
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */
  getPatientData(patient) {
    this.identificationList=new MatTableDataSource<Identification>([]); 
    if (patient.ctos || patient.blocked || patient.deceased || patient.merged || patient.isInactive) {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "30%",
        data: {
          display:
            patient.mrn +
            " / " +
            patient.fullName +
            " / " +
            (patient.gender ? patient.gender : "Unknown") +
            " / " +
            (patient.dateOfBirth ? patient.dateOfBirth : ""),
          info: patient.deceased
            ? this.langService.get("EncounterPage.unabletoProceedDecease")
            : patient.merged
            ? this.langService.get("EncounterPage.unabletoProceedMerge")
            : patient.blocked
            ? this.langService.get("EncounterPage.selectPatientBlock")
            :this.langService.get("EncounterPage.selectPatientInactive")
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (
            result != undefined &&
            result.confirm &&
            result.confirm == "yes"
          ) {
            this.clearAllPatientEncounter();
          } else {
            this.clearAllPatientEncounter();
          }
        })
      );
    } else {
      this.isVip = patient.vip;
      this.isVip == true ?  this.isDisabled = true : this.isDisabled = false;
      this.isNoteVisible = patient.patientNotes ? patient.patientNotes :"";
      this.getPreviousEncounters(patient.mrn);
      this.selectedPatient = patient;
      this.selectedPrimaryId = this.selectedPatient
                 ? this.selectedPatient.idNo
                 : "";
      this.genderValue = this.selectedPatient
        ? this.selectedPatient.gender
        : "";
      this.identifierTypeValue = this.selectedPatient
        ? this.selectedPatient.identifierType
        : "";
      this.titleValue = this.selectedPatient ? this.selectedPatient.title : "";
      this.countryValue = this.selectedPatient
        ? this.selectedPatient.extendedAddress
          ? this.selectedPatient.extendedAddress.country
          : null
        : null;
      // this.getDocuments(patient.mrn);
      this.getPreviousPayerList(patient.mrn);
      var dobFormatted = "";
      var patientAge = undefined;
      if (patient.dateOfBirth) {
        dobFormatted = patient.dateOfBirth
        ? (this.langaugeValue== Langauge.TH
          ? this.thConvertService.convertThaiDateString(patient.dateOfBirth)
          : this.datepipe.transform(patient.dateOfBirth, "dd-MM-yyyy"))
        : null;
        let dobDate = new Date(patient.dateOfBirth);
        patientAge = this.utilsService.getAge(dobDate);
        patientAge =
          patientAge > 1
            ? "(" + patientAge + " Years)"
            : "(" + patientAge + " Year)";
      }
      this.patientInfoDisplay =
        patient.mrn +
        " / " +
        patient.fullName +
        " / " +
        (patient.gender ? patient.gender : "Unknown") +
        " / " +
        (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");

      this.patientImage = patient.photo ? patient.photo.url : "";
      this.formRegistration.enable();
      this.patientId = patient.id;
      this.formEncounter.controls["visittype"].setValue("ER");
    
      if (patient.patientNotes)
        this.formEncounter.controls["reportRemarks"].setValue(
          patient.patientNotes
        );        
        if (patient.identifierType=="Passport") {
          this.formRegistration.controls["expiryDate"].enable();
          this.isexpiryDate = true;
        } else {
          this.formRegistration.controls["expiryDate"].setValue("");
          this.formRegistration.controls["expiryDate"].disable();
          this.isexpiryDate = false;
        }   
        this.countryCode= this.selectedPatient.countryCode;
       let countrycodeObj = this.countryCodeLists.find(
        (code) => code.code === this.countryCode
      );
      this.setPatternToMobileNumber(countrycodeObj);

      this.isPrimaryNoEditable=patient.identifierType?true:false;
      this.formRegistration.patchValue({
        id: patient.id,
        mrn: patient.mrn,
        primaryNumber: patient.idNo,
        primaryId: patient.identifierType ? patient.identifierType : "",
        expiryDate: patient.expiryDate ? new Date(patient.expiryDate) : "",
        issuedCountryPrimary: patient.idIssueCountry
          ? patient.idIssueCountry
          : "",
        issuedCountrySecondary: "",
        firstName: patient.fullName,
        // aliasName: patient.aliasName ? patient.aliasName : "",

        dateOfBirth: patient.dateOfBirth ? new Date(patient.dateOfBirth) : "",
        birthTime: patient.birthTime ? patient.birthTime : "",
        realdob: patient.real ? patient.real : false,
        birthplace: patient.birthlocation ? patient.birthlocation : "",
        motherName: patient.motherName ? patient.motherName : "",
        patientNotes: patient.patientNotes ? patient.patientNotes : "",
        
        doctor:patient.doctor ?patient.doctor:"",
        department:patient.department? patient.department:"",
        
        clinic:patient.clinic ? patient.clinic:"",

        addressPrimary: patient.extendedAddress
          ? patient.extendedAddress.addressLine
          : "",

        cityPrimary:
          patient.extendedAddress && patient.extendedAddress.city
            ? patient.extendedAddress.city
            : "",
        subDistrictPrimary:
          patient.extendedAddress && patient.extendedAddress.area
            ? patient.extendedAddress.area
            : "",
        pincodePrimary: patient.extendedAddress
          ? patient.extendedAddress.postCode
          : "",
        emailId: patient.emailId,
        homeContact: patient.homeContactNo,
        mobileNumber: patient.mobileNumber,
        addressSecondary: patient.correspondingAddress
          ? patient.correspondingAddress.addressLine
          : "",

        pincodeSecondary: patient.correspondingAddress
          ? patient.correspondingAddress.postCode
          : "",
        workContact: patient.workContactNo,
        contactRelation: patient.relation ? patient.relation : "",
        isDeceased: patient.deceased ? patient.deceased : "",
        isBlocked: patient.blocked ? patient.blocked : "",
        isVip: patient.vip ? patient.vip : false,
        isNewborn: patient.newBorn ? patient.newBorn : false,
        workFax: patient.workFax ? patient.workFax : "",
        personalFax: patient.personalFax ? patient.personalFax : "",
        secondaryExpirydate: patient.seondaryExpiryDate
          ? new Date(patient.seondaryExpiryDate)
          : "",
      });
    //   if(patient.identifierType != ""){
    //   let primaryIdValue = this.primaryIdFilteredList.find(e=>e.desc==patient.identifierType);
    //   if(primaryIdValue.isMyKad) this.primaryNumberOnKeyUp(patient.idNo);
    // }
     if (patient.primaryIdentificationList.length>0 || patient.secondaryIdentificationList.length>0) {
              const tempData: any[] = [];
              // Handle Primary Identification
              patient.primaryIdentificationList?.forEach((element) => {
                const idTypeCode = this.getObjByCode(this.primaryIdFilteredList, element.code);
                const data = {
                  identifierUUID: element.identifierUUID || '',
                  type: 'P',
                  idType: element.code,
                  idNumber: element.value?element.value:"",
                  expDate: element.expiryDate,
                  primaryIdRegex: OPD_CONST.primaryIdRegix,
                  isExpiryRequired: element.display === "Passport",
                  issuingCountry: element.issuingCountryCode || '',
                  isCopied: element.status === false,
                  isIdNumberValid:element.value.length>0?true:false,
                  isCountryRequired:false
                };
            
                if (element.status) {
                  this.identificationList.data.push(data);
                  const newIndex = this.identificationList.data.length - 1;
                  this.primaryIdentificationOnChange(idTypeCode, false, newIndex);
                } else {
                  tempData.unshift(data); 
                }
              });
            
              // Handle Secondary Identification
              patient.secondaryIdentificationList?.forEach((element) => {
                if (element.status) {
                  const data = {
                    identifierUUID: element.identifierUUID || '',
                    type: 'S',
                    idType: element.code,
                    idNumber: element.value?element.value:"",
                    expDate: element.expiryDate,
                    issuingCountry: element.issuingCountryCode || '',
                    primaryIdRegex: OPD_CONST.primaryIdRegix,
                    isExpiryRequired: false,
                    isIdNumberValid:element.value.length>0?true:false,
                    isCountryRequired:false
                  };
                  this.identificationList.data.push(data);
                }
              });
            
              const sorted = this.identificationList.data
                .filter(d => !d.isCopied)
                .concat(tempData);
              this.identificationList.data = [...sorted];
            
            } else {
              this.addEmptyIdentificationEntry("P");
            }
            
            this.selectedPatientIdentificationList = JSON.parse(JSON.stringify(this.identificationList.data));
    

    this.getStatePrimaryList(
      patient.correspondingAddress && patient.correspondingAddress.country != ""
        ? patient.correspondingAddress.country
        : patient.extendedAddress.country,
      true
    );
      if (
        patient.extendedAddress.addressLine ==
          patient.correspondingAddress.addressLine &&
        patient.extendedAddress.postCode ==
          patient.correspondingAddress.postCode
      ) {
        this.isBothAddressSame = true;
      }
    }
  }

  /**
   *temporary patient details
   *
   * @param {string} trnNumber
   * @memberof PatientRegistrationComponent
   */
  getTemporaryPatient(trnNumber: string) {
    this.patientForm = true;
    this.patientTRN = trnNumber;

    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_TEMP_PATIENT_SEARCH + trnNumber
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res) {
          this.patientInfoDisplay = "";
          this.patientInfoDisplay =
            res.trn +
            " / " +
            res.patientName +
            " / " +
            (res.genderList ? res.genderList[0].display : "Unknown");
          this.selectedPatient = null;
          (this.identifierTypeValue = res.primaryIdentificationType
            ? res.primaryIdentificationType[0].code
            : ""),
            (this.titleValue = res.prefixList ? res.prefixList[0].code : ""),
            (this.genderValue = res.genderList ? res.genderList[0].code : ""),
            this.formRegistration.patchValue({
              prefix: res.prefixList ? res.prefixList[0].code : "",
              emailId: res.email,
              firstName: res.patientName,
              dateOfBirth: res.dob,
              mobileNumber: res.mobileNo,
              homeContact: res.homeNo,
              workContact: res.officeNo,
              primaryNumber: res.idNumber,
              expiryDate: res.idExpiry ? new Date(res.idExpiry) : "",
              addressPrimary: res.extendedAddress
                ? res.extendedAddress.addressLine
                : "",

              countryPrimary:
                res.extendedAddress && res.extendedAddress.countryList
                  ? res.extendedAddress.countryList[0].code
                  : "",
              statePrimary:
                res.extendedAddress && res.extendedAddress.stateList
                  ? res.extendedAddress.stateList[0].code
                  : "",
              cityPrimary:
                res.extendedAddress && res.extendedAddress.cityList
                  ? res.extendedAddress.cityList[0].code
                  : "",
              subDistrictPrimary:
                res.extendedAddress && res.extendedAddress.areaList
                  ? res.extendedAddress.areaList[0].code
                  : "",
              pincodePrimary: res.extendedAddress
                ? res.extendedAddress.postCode
                : "",
            });
        }
      });
  }

  /**
   *get documents using MRN
   *
   * @param {*} mrn
   * @memberof SamplePatientRegistrationComponent
   */
  // getDocuments(mrn) {
  //   this.fileUploadRegList = [];
  //   this.appBaseService.setResourceURL(OPD_API_URL.FILE_SERVICE);
  //   this.appBaseService
  //     .getFileResource(OPD_API_URL.OPD_FILE_GET + "?mrn=" + mrn)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((res) => {
  //       if (res.payload) {
  //         res.payload.forEach((element) => {
  //           if (element.visitNo == null || element.visitNo == "") {
  //             let docType = this.docTypeFilteredList.find((data) => {
  //               return data.code == element.documentTypeMaster.code;
  //             });
  //             this.fileUploadRegList.push({
  //               id: element.id,
  //               fileType: docType.code,
  //               fileName: element.fileName,
  //               files: element.data,
  //               fileDescription: element.fileDescription,
  //               mrn: element.mrn,
  //               isUploaded: true,
  //             });
  //           }
  //         });
  //       }

  //       this.fileSourceReg = new MatTableDataSource(this.fileUploadRegList);
  //     });
  // }

  /**
   *get previous encounters data
   *
   * @param {*} patientMrn
   * @memberof SamplePatientRegistrationComponent
   */
  getPreviousEncounters(patientMrn) {
    let list = [];
    this.formEncounter.reset();
    let reqPayload = patientMrn + OPD_API_URL.OPD_PREVIOUS_ENCOUNTERS;

    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_ENCOUNTER_LIST + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res && res.totalRecords > 0) {
          res.response.forEach((element, index) => {
            this.patientImage = element.patient
              ? element.patient[0]
                ? element.patient[0].photo[0].url
                : ""
              : "";
            var utcSeconds = element.createdDate;
            var encounterDate = new Date(0);
            this.previousInternalNotes = element.encounterNote;
            this.internotesEncounterNo = element.encounterNumber;
            this.internotesEncounterid = element.id;
            list.push({
              EncounterId: element.id,
              VisitDate: utcSeconds
                ? (this.langaugeValue== Langauge.TH
                  ? this.thConvertService.convertToThaiDate(utcSeconds) :  this.datepipe.transform(utcSeconds*1000, "dd/MM/yyy hh:mm aa")): null,
              VisitNumber: element.encounterNumber,
              visitType: element.visitType ? element.visitType.display : "",
              Department: element.department ? element.department.display : "",
              DoctorName: element.doctor ? element.doctor.display : "",
              OutstandingAmount: "0.00",
              BillNumber: "",
              payer:element.payer ? element.payer :"",
  
              BillAmount: element.billAmount ? element.billAmount : "0.00",
            });
            if (index == res.totalRecords - 1) {
              this.encounterTypeValue = element.encounterType
                ? element.encounterType.code
                : "";
              this.departmentValues = element.department
                ? element.department.code
                : "";
              this.doctorValue = element.doctor ? element.doctor.code : "";
            }
          });
        }
        this.previousEncounterList = list;
        this.dataSourceEncounters =
          new MatTableDataSource<priviousEncounterObject>(list);
      });
  }

  /**
   *get list data by code
   *
   * @param {any[]} list
   * @param {string} code
   * @return {*}  {string}
   * @memberof SamplePatientRegistrationComponent
   */
  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }

  /**
   *confirm window
   *
   * @memberof SamplePatientRegistrationComponent
   */
  confirmClearPatientEncounter() {
    const dialogRefConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { confirm: "no" },
    });
    this.subscriptionList.add(
      dialogRefConfirm.afterClosed().subscribe((result) => {
        if (result.confirm == "yes") {
          this.clearAllPatientEncounter();
        }
      })
    );
  }

  /**
   *validate registration
   *
   * @return {*}  {boolean}
   * @memberof SamplePatientRegistrationComponent
   */

  validateRegistration(): boolean {
    if (this.isDeceased) {
      return this.formRegistration.valid;
    } else{
      if(!this.formRegistration.controls["mobileNumber"].valid){
        this.formRegistration.controls["mobileNumber"].markAsTouched();
        this.snackBar.open(
        this.langService.get("CommonAppoinment.addDependend"),
          this.langService.get("CommonAppoinment.validation"),
        {duration:1000}
        );
        return this.formRegistration.valid;
    } else {
      for (var i in this.formRegistration.controls) {
        this.formRegistration.controls[i].markAsTouched();
      }
      if (!this.formRegistration.valid) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleasefillallmandatory"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 1000,
          }
        );
      }
      return this.formRegistration.valid;
    }
  }
  }

  /**
   *Validation encounter
   *
   * @return {*}  {boolean}
   * @memberof SamplePatientRegistrationComponent
   */
  validateEncounter(): boolean {
    let valid = true;
    let payersList = this.dataSourcePayers.data;
    if (payersList.length > 0) {
      payersList.forEach((element) => {
        if (element.payerCode == "" || element.payerCode == undefined) {
          valid = false;
          this.snackBar.open(
            this.langService.get("EncounterPage.pleaseselectreferrconpamy"),
            this.langService.get("CommonAppoinment.validation"),
            {
              duration: 3000,
            }
          );
        }
      });
    }
    if (payersList.length > 0) {
      payersList.forEach((element) => {
        if (element.tariffCode == "" || element.tariffCode == undefined) {
          valid = false;
          this.snackBar.open(
            this.langService.get("CommonAppoinment.PleaseSelectTariff"),
            this.langService.get("CommonAppoinment.validation"),
            {
              duration: 1000,
            }
          );
        }
      });
    }
    if (valid) {
      for (var i in this.formEncounter.controls) {
        this.formEncounter.controls[i].markAsTouched();
      }
      valid = this.formEncounter.valid;

      if (!valid) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleasefillallmandatory"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 1000,
          }
        );
      }
    } 
    if (this.mandatoryField.identificationType || this.mandatoryField.identificationNo) {
      for (const element of this.identificationList.data ) {
        if (element.type === "P" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid)) {
          this.snackBar.open("Please check Primary Identification Details", "Validation", { duration: 2000 });
          valid = false;
        }
      }
    }
    if (this.mandatoryField.secIdentificationType || this.mandatoryField.secIdentificationNo) {
      for (const element of this.identificationList.data) {
      if (element.type === "S" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid)) {
        this.snackBar.open("Please check Secondary Identification Details", "Validation", { duration: 2000 });
        valid = false;
      }
      }
    }
    return valid;
  }

  /**
   *patient search
   *
   * @memberof PatientRegistrationComponent
   */
  public initSearchFilter() {
    this.subscriptionList.add(
      this.searchHead
        .getTypeSearch(OPD_API_URL.M_PAT_REG_SEARCH)
        .subscribe((data: any) => {
          this.searchHead.updateSearchHeader(data);
        })
    );

    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        let result = { mrn: quickSearch };
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      }
    );
    this.subscriptionList.add(quickSearch);
  }

  /**
   *save encounter
   *
   * @memberof SamplePatientRegistrationComponent
   */
   saveEncouter() {
    if (this.validateRegistration() && this.validateEncounter()) {
      if(this.formRegistration.controls["isVip"].value) {
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "15%",
          data: { displayText: "conformVipMessage"},
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result.confirm == "yes") {
              this.openRegisterConfirmationDialog();
            }
          })
        );
      } else {
        this.openRegisterConfirmationDialog();
      } 
    }
 }

  openRegisterConfirmationDialog(): void {
    const dialogRef = this.dialog.open(RegsuccessDialogComponent, {
      width: "20%",
      data: {},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.workflow == "yes") {
          this.openEncounterConfirmDialog();
        }
      })
    );
  }

  /**
   *save patient and encounter
   *
   * @memberof SamplePatientRegistrationComponent
   */
  openEncounterConfirmDialog() {
     let patient:PatientRegistration=
    this.patientRegService.getRegistrationFormValues(
      this,
      this.formRegistration
    );
    let encounter = this.patientRegService.getEncounterFormValues(
      this,
      this.formEncounter
    );
    encounter.defaultDeposit = this.defaultDeposit;
     let dataSourcePayers = this.patientRegService.getEncounterPayerFormValues(
      this,
      this.dataSourcePayers
    );
   
    let requestPatientPayload = this.patientRegService.setSavePayload(
      this,
      patient
    );
    let requestEncounterPayload = this.patientRegService.setEncounterSave(
      this,
      encounter,
      dataSourcePayers,
      null
    );

    let requestObject = {
      patientRequest: requestPatientPayload,
      encounterRequest: requestEncounterPayload,
    };
    this.subscriptionList.add(
      this.generalApiService
        .postTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.S_EMERGENCY_REGISTRATION,
          requestObject
        )
        .subscribe((response: any) => {
          if (response && response.id) {
            let encounterNumber = response.encounterNumber
              ? response.encounterNumber
              : response.identifier[0]
              ? response.identifier[0].value
              : "";

            this.snackBar.open(
              this.langService.get("EncounterPage.encounterHeader") +
                ": " +
                encounterNumber +
                " " +
                this.langService.get("EncounterPage.patientSaved"),
              this.langService.get("CommonAppoinment.success"),
              {
                duration: 1000,
              }
            );

            this.encounternumber = response.encounterNumber;
            this.previousInternalNotes = [];
            this.internalNotesList = [];
            this.printPayload = {
              transactionId: response.id,
              type: OPD_REPORT_TYPE.pdf,
              reportName: OPD_REPORT_NAME.encounter_Slip,
              isReports: false,
            };
            localStorage.setItem(
              OPD_CONST.reportPayload,
              JSON.stringify(this.printPayload)
            );
            window.open(opdNavigation.REPORT_NAVIGATE);
            const secondPrintPayload = {
              transactionId: response.id,
              type: OPD_REPORT_TYPE.pdf,
              reportName: OPD_REPORT_NAME.asmission_Label, 
              isReports: false,
            };
            localStorage.setItem(
              OPD_CONST.reportPayload2,
              JSON.stringify(secondPrintPayload)
            );
            window.open(opdNavigation.REPORT_NAVIGATE );
            this.clearAllPatientEncounter();
          }
        })
    );
  }

  /**
   *mobile format
   *
   * @param {string} value
   * @param {string} name
   * @memberof SamplePatientRegistrationComponent
   */
  // mobileFormat(value: string, name: string) {
  //   var r = /(\D+)/g,
  //     npa = "",
  //     last4 = "";
  //   value = value.replace(r, "");
  //   npa = value.substr(0, 3);
  //   last4 = value.substr(3, 10);
  //   value = npa + "-" + last4;
  //   if (value.replace("-", "").trim() == "") value = "";
  //   if (name == "mobile") {
  //     this.formRegistration.controls.mobileNumber.setValue(value);
  //   }
  // }

  /**
   *clear allthe data
   *
   * @memberof SamplePatientRegistrationComponent
   */
  clearAllPatientEncounter() {
    localStorage.removeItem("appointmentData");
    localStorage.removeItem("admissionRequest");
    this.previousInternalNotes = [];
    this.internalNotesList = [];
    this.patientId = "";
    this.patientImage='';
    this.selectedPatient = {};
    this.isSelectedPatient=false;
    this.patientInfoDisplay='';
    this.defaultDeposit = "";
    this.formRegistration.reset();
    this.formEncounter.reset();
    this.formRegistration.enable();
    this.formRegistration.controls["expiryDate"].setValue("");
    this.formRegistration.controls["expiryDate"].disable();

    let patientEncounterPayer = new PatientEncounterPayer();
    patientEncounterPayer.isSelf = true;
    this.dataSourcePayers = new MatTableDataSource<any>([
      patientEncounterPayer,
    ]);
    this.getFirstName()
    this.getPayerTypeList();
    this.getPayerList();
    this.fillDropDownLists();
    this.getScreenConfigurations();
    this.checkFields(true);
    this.formRegistration.get('isKnown').setValue(true);
    this.identificationList = new MatTableDataSource<Identification>([]);
    this.selectedPatientIdentificationList=[];
    this.addEmptyIdentificationEntry("P");
  }

  /**
   *primary identification value
   *
   * @param {*} idTypeCode
   * @memberof SamplePatientRegistrationComponent
   */
  //

  primaryIdentificationOnChange(idTypeCode: any, isPrimaryNoRemove:boolean,index?) {    
     var formRegistration = this.formRegistration.controls;
     if(isPrimaryNoRemove){
     this.identificationList.data[index].idType=idTypeCode.value;
     this.identificationList.data[index].idNumber="";
     if(this.identificationList.data[index].type=='P'){
      this.mandatoryField.identificationType=true;
      this.mandatoryField.identificationNo=true;
     }else{
      this.mandatoryField.secIdentificationType=true;
      this.mandatoryField.secIdentificationNo=true;
     }
     }
     if(this.identificationList.data[index].type=='P'){
     if (idTypeCode?.value) {
       this.primaryIdCode = this.primaryIdFilteredList.find(
         (s) => s.code == idTypeCode.value
       );
     }else{
         this.primaryIdCode = this.primaryIdFilteredList.find(
           (s) => s.code == idTypeCode.code
         );
       }
     }else{
       if (idTypeCode?.value) {
         this.primaryIdCode = this.secondaryIdFilteredList.find(
           (s) => s.code == idTypeCode.value
         );
       }else{
           this.primaryIdCode = this.secondaryIdFilteredList.find(
             (s) => s.code == idTypeCode.code
           );
         }
     }
       // let primaryIdCode = formRegistration.primaryId.value;
       if (this.primaryIdCode) {        
         this.primaryIdNewValue=this.primaryIdCode.code?this.primaryIdCode.code:"";
         if (this.primaryIdCode.isMyKad == true) {
           formRegistration["nation"].setValue("MALAYSIAN");
           this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
         } else {
           this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation
             ? this.primaryIdCode.validation
             : "";
         }
       }
       // if (!this.selectedPatient) {
         if (this.primaryIdCode.isExpireReq) {
           this.identificationList.data[index].isExpiryRequired = true;
         } else {
           this.identificationList.data[index].expDate="";
           this.identificationList.data[index].isExpiryRequired = false;
         }
         this.primaryNumberOnKeyUp(this.identificationList.data[index].idNumber,index);
       // }
       if (this.primaryIdCode.expiryDuration) {
         const currentDate = new Date().getFullYear();
         const maxExpiryDurationDate = new Date();
         maxExpiryDurationDate.setFullYear(currentDate + this.primaryIdCode.expiryDuration);
 
         this.maxExpiry = maxExpiryDurationDate;
       }
       else{
         this.maxExpiry= new Date(this.year + 20, this.month, this.day);
       }
      if (this.primaryIdCode.validation) {
       this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation;
        const match = this.identificationList.data[index].primaryIdRegex.match(/\{(\d+),(\d+)\}/);
        this.identificationList.data[index].minIdentificationLength = match ? parseInt(match[1], 10) : null;
        this.identificationList.data[index].maxIdentificationLength = match ? parseInt(match[2], 10) : null;
      }else{
       this.identificationList.data[index].maxIdentificationLength=25;
       this.identificationList.data[index].minIdentificationLength=0;
       this.identificationList.data[index].primaryIdRegex=OPD_CONST.primaryIdRegix;
      }
      this.formRegistration.controls["primaryNumber"].updateValueAndValidity();
      if(!this.identificationList.data[index].issuingCountry)
      this.identificationList.data[index].isCountryRequired = this.primaryIdCode ? this.primaryIdCode.isCountryRequired : false;
     
     this.primaryIdSelect(idTypeCode.value);
   }
  
  primaryIdSelect(value){
    this.isPrimaryNoEditable=value?true:false;
  }
  
  /**
   *
   *
   * @param {*} event
   * @memberof SamplePatientRegistrationComponent
   */

  editPatientClicked() {
    if (this.selectedPatient) {
      const formRegistration = this.formRegistration.controls;
      const IdTypeCode = formRegistration["IdTypeCode"].value;

      if (IdTypeCode) {
        this.isexpiryDate = IdTypeCode.isExpireReq;

        if (!this.isexpiryDate) {
          formRegistration["expiryDate"].setValue("");
          formRegistration["expiryDate"].disable();
          this.isexpiryDate = true;
        
        }else {
          formRegistration["expiryDate"].enable();
          this.isexpiryDate = false;
        }
      }
    }
  }
  /**
   *
   *
   * @param {*} prefixvalue
   * @memberof SamplePatientRegistrationComponent
   */
  getGender(prefixvalue) {
    let formRegistration = this.formRegistration.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["gender"].disable();
    } else {
      this.genderValue = this.genderValue ? this.genderValue :"" ;
      if(this.isRegistered){
        formRegistration["gender"].disable();
       }else{
        formRegistration["gender"].enable();
      }
    }
  }

  primaryNumberOnKeyUp(value: string,index?) {
    this.identificationList.data[index].idNumber=value;
    try {
      let formRegistration = this.formRegistration.controls;
      let primaryIdCode = this.identificationList.data[index].idType

      value = value.replace(/\s/g, '');
      this.identificationList.data[index].idNumber=value;
      if (primaryIdCode) {
        let primaryIdentify = this.primaryIdList.find(
          (i) => i.code == primaryIdCode
        );
        if (primaryIdentify) {
          if (primaryIdentify.isMyKad) {
            value = value.replace(/[^\d*]/g, '');
            this.identificationList.data[index].maxIdentificationLength=14;
            this.identificationList.data[index].minIdentificationLength=0;
            var r = /[^0-9*]+/g,
              npa = "",
              nxx = "",
              last4 = "";
            value = value.replace(r, "");
            var c: string = value;
            npa = value.substr(0, 6);
            nxx = value.substr(6, 2);
            last4 = value.substr(8, 4);
            value = npa + "-" + nxx + "-" + last4;
            this.identificationList.data[index].idNumber=value ? value : "";
            this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
          } else if (primaryIdentify.isMyKad == false) {
            this.identificationList.data[index].primaryIdRegex = "[A-Za-z0-9]*";
            this.identificationList.data[index].idNumber=value ? value : "";
          }

          if (value.length >= 12 && primaryIdentify.isMyKad) {
            const array = Array.from(c);
            const yearSuffix = parseInt(array[0] + array[1], 10);
            const cal_month = parseInt(array[2] + array[3], 10);
            const cal_day = parseInt(array[4] + array[5], 10);
            const contry = array[6] + array[7];
            const gen_val = array[11];
  
            BirthPlaceList.forEach(element => {
              if (element.birthPlaceNumber == contry) {
                this.formRegistration.patchValue({
                  birthplace: element.birthPlaceName
                });
              }
            });

            const lastDigit = Number(gen_val);
            let genderVal = lastDigit % 2 == 0 ? STATICCODESERVICE.GENDER_MASTER_FEMALE : STATICCODESERVICE.GENDER_MASTER_MALE;
            this.genderValue = this.patientRegService.getCodeByStaticCode(this.genderList, genderVal);
  
            var currentYear = new Date().getFullYear();
            var currentYearSuffix = currentYear % 100;
  
            let yr;
            if (yearSuffix > currentYearSuffix) {
              yr = 1900 + yearSuffix;
            } else {
              yr = 2000 + yearSuffix;
            }
  
            var birthDate = new Date(yr, cal_month - 1, cal_day);
            var today = new Date();
  
            if (birthDate > today && !this.isSameDate(birthDate, today)) {
              yr -= 100;
              birthDate = new Date(yr, cal_month - 1, cal_day);
            }
            
            if (this.isValidDate(yr, cal_month, cal_day)) {
              formRegistration["dateOfBirth"].setValue(birthDate);
              formRegistration["realdob"].setValue(true);
            } else {
              this.snackBar.open(
                this.langService.get("CommonAppoinment.InvalidNRIC"),
                this.langService.get("CommonAppoinment.validation"),
                { duration: 1000 }
              );
              this.identificationList.data[index].idNumber="";
              formRegistration["birthplace"].setValue(null);
              this.genderValue = "";
              formRegistration["dateOfBirth"].setValue(null);
              formRegistration["realdob"].setValue(false);
            }
          }
        }
      }
    } catch (ex) {}
  }
  /**
   *
   *
   * @param {string} value
   * @memberof SamplePatientRegistrationComponent
   */
  onFocusOutEvent(value: any , index: number) {
    if(value.type=="P"){
      this.validationOnPrimarynumber(this.identificationList.data[index]?.idNumber ,index);
    }
    if (value.identifierUUID && this.patientId) {
      value.identifierOverride = true;
      value.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
    let primaryIdCode:any = this.getObjByCode(
      this.identificationList.data[index]?.type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
      this.identificationList.data[index]?.idType
    );
    if (primaryIdCode) {
      if (primaryIdCode.isMyKad && this.identificationList.data[index]?.idNumber.length < 14)
        this.identificationList.data[index].isIdNumberValid=false;
      else
        this.identificationList.data[index].isIdNumberValid=true;
    }
  }

  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof SamplePatientRegistrationComponent
   */
  validationOnPrimarynumber(value: string , index:number) {
    if (value) {
      let input = value;
      this.output = input.replace(/-/g, '');
    }
    if (this.selectedPatientIdentificationList[index].idNumber!==value) {
    // if (this.patientId == "" && value.length > 0) {
      let primaryIdCode = this.identificationList.data[index].idType;
      if (primaryIdCode) {
        this.generalApiService
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode + "&value=" + value.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((response:any) => {
            if(response && response.status==409){
              this.identificationList.data[index].idNumber="";
            }else{
              this.identificationList.data[index].idNumber=value;
            }
          });
      }
    }
  }

  /**
   *Calcuate DOB
   *
   * @param {string} age
   * @param {string} month
   * @memberof SamplePatientRegistrationComponent
   */
  calculateDob(age: string, month: string) {
    let formRegistration = this.formRegistration.controls;

    let agecalc;
    let monthcalc;

    if (age != "0") {
      agecalc = age.split("Y", 1);
    } else {
      agecalc = 0;
    }
    if (month != "0") {
      monthcalc = month.split("M", 1);
    } else {
      monthcalc = 0;
    }
    var todayDate = new Date();
    var ageyear = todayDate.getFullYear() - Number(agecalc);
    var agemonth = todayDate.getMonth() - Number(monthcalc);
    var ageday = todayDate.getDate() - 0;
    formRegistration["dateOfBirth"].setValue(new Date(ageyear, agemonth, ageday));
  }

  /**
   *Get Payerlist
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getPayerList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_COMPANY)
        .subscribe((data: any) => {
          this.payerList = data;
          this.payerFilteredList = data;
          if(!this.selectedPatient){
            let res = this.payerList.find((s) => s.isSelf == true);
            this.dataSourcePayers.data[0].payerCode = res.code;
          }
          this.dataSourcePayers.data[0].payerList = []
          this.dataSourcePayers.data[0].payerList = data;
          this.dataSourcePayers.data[0].payerFilteredList = data;
          // this.getPayerTypeList();
        })
    );
  }

  /**
   *It is the source of payerType data.
   *
   * @memberof PatientRegistrationComponent
   */
  getPayerTypeList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_COMPANYTYPE)
        .subscribe((data: any) => {
          this.payerTypeList = data;
          this.payerTypeFilteredList = data;
          let res = this.payerTypeList.find((s) => s.isSelf == true);
          this.dataSourcePayers.data[0].payerTypeCode = res.code;
          // this.getPayerListData(res.code, 0);
        })
    );
  }

  /**
   *It is get the tariffMaster Data
   *
   * @memberof PatientRegistrationComponent
   */
  getTariffmaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_TARIFF)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.tariffList = res;
        this.tariffFilteredList = res;
  
        // ✅ Bind tariff list to each row
        this.dataSourcePayers.data.forEach((payer, index) => {
          if (!payer) return;
          payer.tariffList = [...res];
          payer.tariffFilteredList = [...res];
  
          // ✅ Auto-select default tariff
          let defaultTariff = res.find((t) => t.isDefault);
          if (defaultTariff) {
            payer.tariffCode = defaultTariff.code;
            payer.isDisableTariff = true;
          }
        });
  
        // ✅ Refresh table data
        this.dataSourcePayers._updateChangeSubscription();
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getContractListData() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_CONTRACT)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.contractList = data;
        this.contractCodeList = data;
  
        // ✅ Bind contract list to each row
        this.dataSourcePayers.data.forEach((payer, index) => {
          if (!payer) return;
          payer.contractList = [...data];
          payer.contractCodeList = [...data];
        });
  
        // ✅ Refresh table data
        this.dataSourcePayers._updateChangeSubscription();
      });
  }

  /**
   *It is the source of getAssociateList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getAssociatedCompanyList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_ASSOCIATECOMPANY)
        .subscribe((data: any) => {
          this.associatedCompanyList = data;
          this.associatedCompanyCodeList = data;
        })
    );
  }

  /**
   *It is the source of primaryId data
   *
   * @memberof PatientRegistrationComponent
   */
  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.primaryIdList = data.filter((i) => i.isPrimaryId);
        this.primaryIdFilteredList = this.primaryIdList;
        this.secondaryIdList = data.filter((i) => !i.isPrimaryId);
        this.secondaryIdFilteredList = this.secondaryIdList;
        // this.secondaryIdFilteredList = data;
      });
  }

  /**
   *It is the source of getGLTypeList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getGLTypeList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_GLTYPE)
        .subscribe((data: any) => {
          this.glTypeList = data;
        })
    );
  }

  /**
   *Change Priority
   *
   * @param {boolean} moveUp
   * @param {number} index
   * @memberof SamplePatientRegistrationComponent
   */
  changePayerPriority(moveUp: boolean, index: number) {
    let list = this.dataSourcePayers.data;
    var element = list[index];
    if (moveUp && index > 0) {
      list.splice(index, 1);
      list.splice(index - 1, 0, element);
    } else if (!moveUp && index != list.length - 1) {
      list.splice(index, 1);
      list.splice(index + 1, 0, element);
    }
    this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);
  }

  /**
   *remove payer
   *
   * @param {*} index
   * @memberof SamplePatientRegistrationComponent
   */
  removePayer(element) {
    let list = this.dataSourcePayers.data;
    const index: number = list.indexOf(element);
    list.splice(index, 1);
    this.dataSourcePayers = new MatTableDataSource<any>(list);
  }

  /**
   *Add payer
   *
   * @memberof SamplePatientRegistrationComponent
   */
  addPayer() {
    let list = this.dataSourcePayers.data;
    let patientEncounterPayer = new PatientEncounterPayer();
    patientEncounterPayer.payerCode = "";
    patientEncounterPayer.priority = list.length + 1;
    if(!this.isFirstPayerPriority){
      list.push(new PatientEncounterPayer());
    }else{
      list.unshift(new PatientEncounterPayer());
    }
    this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);
  }

  /**
   *Passing payerCode and index to get the contractList
   *
   * @param {*} payerCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getPayerListData(payerTypeCode, element) {
    let resPayerCode = this.payerTypeList.find((s) => s.code == payerTypeCode);
    if (resPayerCode.isSelf && this.dataSourcePayers.data.length > 1) {
      let index = this.dataSourcePayers.data.indexOf(element);
      this.dataSourcePayers.data[index].payerTypeCode = "";

      this.snackBar.open(
        this.langService.get("CommonAppoinment.selectotherpayertype"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 2000,
        }
      );
    } else {
      let res = this.payerList.find((s) => s.isSelf == resPayerCode.isSelf);
      this.dataSourcePayers.data[0].payerCode = res ? res.code : "";
    }
  }

  /**
   *Add internal notes
   *
   * @memberof SamplePatientRegistrationComponent
   */
  addInternalNotes() {
    const dialogRef = this.dialog.open(PatientNotesDialogComponent, {
      height: "350px",
      width: "1000px",
      data: {
        listNotes: this.previousInternalNotes,
        name: "Emergency",
        encounterno: this.internotesEncounterid,
        encounterId:this.internotesEncounterNo,
        isPrint:false
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        let res = result;
        this.internalNotesList = res;
      })
    );
  }

  isSameDate(date1, date2) {
    return date1.getFullYear() == date2.getFullYear() &&
           date1.getMonth() == date2.getMonth() &&
           date1.getDate() == date2.getDate();
  }
  
  isLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
  }

  isValidDate(year, month, day) {
    if (month < 1 || month > 12) {
      return false;
    }
  
    let daysInMonth;
    if (month == 2) {
      daysInMonth = this.isLeapYear(year) ? 29 : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
      daysInMonth = 30;
    } else {
      daysInMonth = 31;
    }
    return day > 0 && day <= daysInMonth;
  }

  // getTariffContract(contractCode,index){
  //   this.contractValue = this.dataSourcePayers.data[index].contractList.find(i => i.code === contractCode);
  //   if (this.contractValue) {
  //     let tariffContract = this.tariffList.find(i=>i.code==this.contractValue.tariffMaster.code)
  //     if(tariffContract){
  //     this.dataSourcePayers.data[index].tariffCode = tariffContract.code
  //    }
  //   }
  // }

  getTariffContractPayer(payerCode: string, index: number) {
    if (payerCode) {
      this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.GET_COMPANY_TARIFF_BY_COMPANYCODE + payerCode)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res: any) => {
          if (res.companyMasterDTOResponse) {
            if (res.companyMasterDTOResponse.tariffResponseList.length > 0) {
            this.dataSourcePayers.data[index].tariffList = res.companyMasterDTOResponse.tariffResponseList;
          }
        }
        });
    }
  }
  
  getTariffContract(contractCode: string, index: number) {
    this.contractValue = this.dataSourcePayers.data[index].contractList.find(i => i.code === contractCode);
    
    if (this.contractValue) {
      let tariffContract = this.tariffList.find(i=>i.code==this.contractValue.tariffMaster.code)
      
      if (tariffContract) {
        this.dataSourcePayers.data[index].tariffCode = tariffContract.code;
        this.dataSourcePayers.data[index].isDisableTariff = true;
      } else {
        this.dataSourcePayers.data[index].isDisableTariff = false;
      }
    }
  }
  getContractPayer(payerCode,index){
    this.dataSourcePayers.data[index].contractList = [];
    this.dataSourcePayers.data[index].contractCodeList = [];
   let payerId =  this.dataSourcePayers.data[index].payerList.find(i=> i.code ==payerCode);
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(
        OPD_API_URL.GET_PAYERTYPE_TYPE  +
        "payerId="+payerId.id+"&visitTypeCode=ER"
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        let data = res;
        this.dataSourcePayers.data[index].contractList = data;
        this.dataSourcePayers.data[index].contractCodeList = data;
      })
  }
  getPayerTypePayer(payerCode,index){
    this.dataSourcePayers.data[index].payerList = []
    this.dataSourcePayers.data[index].payerFilteredList = []
    let payerTypeId =   this.payerTypeList.find(i=>i.code ==payerCode);
   
     this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
     this.appBaseService
       .getResource(
         OPD_API_URL.GET_CONTRACT_PAYER  +
         payerTypeId.id
       )
       .pipe(takeUntil(this._onDestroy))
       .subscribe((res) => {
         let data = res;
        this.dataSourcePayers.data[index].payerList = data;
        this.dataSourcePayers.data[index].payerFilteredList = data;
       })
   }
   getPreviousPayerList(mrn?) {
    this.existingPayerList = [];
    let glattachmentList = [];
    let mrnValue=mrn?mrn:"";
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.OPD_PAYER_ALL_DETAILS + mrnValue+"&visitType="+"OP")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res.length > 0) {
          res.forEach((ele) => {
            let referralNoList = [];
            glattachmentList = ele.glAttachmentList
              ? ele.glAttachmentList
              : null;
            if (glattachmentList && glattachmentList.length > 0) {
              glattachmentList.forEach((element) => {
                let list = {
                  glrefno: element.glAttachmentNo ? element.glAttachmentNo : "",
                  glbalance: element.availableBal ? element.availableBal : 0,
                  effectiveDate: element.effectiveDate
                    ? element.effectiveDate
                    : "",
                  expiryDate: element.expiryDate ? element.expiryDate : "",
                
                  glTypeCode: element.glType ? element.glType.code : "",
                  polictyNo: element.glReferenceNo ? element.glReferenceNo : "",
                };
                referralNoList.push(list);
              });
            }
            let obj = {
              payerTypeCode: ele.payerType ? ele.payerType.code : "",
              payerCode: ele.payer ? ele.payer.code : "",
              tariffCode: ele.tariff ? ele.tariff.code : "",
              glTypeCode:
              ele.company && ele.company.isAutoApproval
              ? statisGlApprovalType.AG
              : statisGlApprovalType.PG,
              effectiveDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].effectiveDate
                  : "",
              expiryDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].expiryDate
                  : "",
              isexpirypayerDate:true,
              glAmount:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glbalance
                  : "",
              glReferenceNo:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glrefno
                  : "",
              policyNumber:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].polictyNo
                  : "",
              contractCode: ele.contract ? ele.contract.code : "",
              associatedCompanyCode: ele.associatedCompany
                ? ele.associatedCompany.code
                : "",
              isSelf: ele.payerType.code === "SELF" ? true : false,
              referralNoList: referralNoList,
            };
            this.existingPayerList.push(obj);
          });
          this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(
            this.existingPayerList
          );
          this.getContractListData();
          this.getTariffmaster();
          this.getPayerList();
          this.existingPayerList.forEach((element ,i)=> {
          this.getPayerTypePayer(element.payerTypeCode,i);
          });
        }
      });
  }

  setPatternToMobileNumber(event){
     if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, '');
      this.formRegistration.controls["mobileNumber"].setValidators([
        Validators.pattern(new RegExp(regexPattern))
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      }else{
      this.formRegistration.controls["mobileNumber"].clearValidators();
      }
    } else {
      this.formRegistration.controls["mobileNumber"].clearValidators();
    }
    this.formRegistration.controls["mobileNumber"].updateValueAndValidity();
  }
  getGlType(element,index){
    let selectedPayer=element.payerList.find(e => e.code == element.payerCode );
     this.dataSourcePayers.data[index].glTypeCode = selectedPayer?.isAutoApproval ? statisGlApprovalType.AG : statisGlApprovalType.PG;
  }
  checkFields(event: any) {
    event.checked ? this.showFields = event.checked :this.showFields = event ;
    if(this.showFields == true){
      this.isDisabledName = true;
      this.getFirstName();
    }else{
      this.isDisabledName = false;
      this.formRegistration.controls["firstName"].setValue("");
    }
  }

  
    /**
   *It is the source of country data.
   *
   * @memberof SamplePatientRegistrationComponent
   */
   getCountryList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_COUNTRY)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryPrimaryList = data;
      });
  }

    /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof EmergencyRegistrationComponent
   */
   getStatePrimaryList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryPrimaryList.find((i) => i.code == countryCode);
      else
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.statePrimaryList = res;
          if (this.selectedPatient) {
            const stateres = this.statePrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.state
                  : "")
            );
            this.stateValue = stateres ? stateres.code : "";
            this.getCityPrimaryList(stateres);
          }
        });
    }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof EmergencyRegistrationComponent
   */
  getCityPrimaryList(stateCode) {
    if (stateCode) {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.cityPrimaryList = res;
          if (this.selectedPatient) {
            const cityres = this.cityPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.city
                  : "")
            );
            this.cityValue = cityres ? cityres.code : "";
            this.getSubDistrictPrimaryList(cityres);
          }
        });
    }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} cityCode
   * @memberof EmergencyRegistrationComponent
   */
  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);
      this.CityCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.subDistrictPrimaryList = res;
          if (this.selectedPatient) {
            const distres = this.subDistrictPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.area
                  : "")
            );
            this.districtValue = distres ? distres.code : "";
          }
        });
    }
  }
  updateVIPStatus(event) {
    // if(event.checked) {
    //   this.isVip = true;
    //   this.formRegistration.controls["isVip"].setValue(true);
    //   this.formRegistration.controls["aliasName"].enable();
    //   this.formRegistration.updateValueAndValidity();
    // } else {
    //   this.isVip = false;
    //   this.formRegistration.controls["isVip"].setValue(false);
    //   this.formRegistration.controls["aliasName"].setValue("");
    //   this.formRegistration.controls["aliasName"].disable();
    //   this.formRegistration.updateValueAndValidity();
    // }
  }
     addIdentification(element): void {
      const { idType, idNumber, expDate, issuingCountry, type, isIdNumberValid } = element;
    
      if (!idType || !idNumber) {
        this.snackBar.open("Please enter identification details", "validation", { duration: 2000 });
        return;
      }
      if(!isIdNumberValid){
        this.snackBar.open("Please enter valid identification Number","Validation",{duration:2000});
      }
      const idTypeCode:any = this.getObjByCode(
        type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
        idType
      );
    
      if (idTypeCode.isExpireReq && !expDate) {
        this.snackBar.open("Please enter expiry date", "validation", { duration: 2000 });
        return;
      }
    
      if (idTypeCode.isCountryRequired && !issuingCountry) {
        this.snackBar.open("Please enter issuing country", "validation", { duration: 2000 });
        return;
      }
      const hasEmptyEntry = this.identificationList.data.some(
        item => !item.idType && !item.idNumber
      );
    
      if (hasEmptyEntry) {
        this.snackBar.open("Blank identification entry already exists", "validation", { duration: 2000 });
        return;
      }
     const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "Do you want to Add another identification entry?" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          this.addEmptyIdentificationEntry("S");
          this.secondaryIdentifierListModified = true;
        }
      })
    );
      
    }
    
    hasPrimarySelected(): boolean {
      return this.identificationList.data.some(item => item.type === 'P');
    }
    isIdTypeSelected(code: string, currentIndex: number): boolean {
      if(this.identificationList.data[currentIndex].type=="S"){
      return this.identificationList.data
        .some((item, index) => index !== currentIndex && item.idType === code);
      }
    }
    onTypeChange(element: string, index: number): void {
      this.identificationList.data[index].type=element;
      if (element === 'P') {
        this.identificationList.data.forEach((item, i) => {
          if (i !== index && item.type === 'P') {
            item.type = 'S';
          }
        });
      }
      this.identificationList.data[index].idType="";
      this.identificationList.data[index].idNumber="";
      this.identificationList.data[index].expDate="";
      this.identificationList.data[index].issuingCountry="";
      this.identificationList.data = [...this.identificationList.data]; 
    }
    setCountryValue(event: any, index: number, element: any): void {
      this.identificationList.data[index].issuingCountry = event;
  
      if (element.identifierUUID && this.patientId) {
        element.identifierOverride = true;
        element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
      }
    }
    onExpiryDateChange(selectedDate: Date, element: any): void {
      element.expDate = selectedDate;
      if (element.identifierUUID && this.patientId) {
        element.identifierOverride = true;
        element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
      }
    }
    deleteIdentification(index: number,element): void {
      if(this.selectedPatientIdentificationList && element.identifierUUID){
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "30%",
          data: { displayText: "deleteConfirm" },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result != undefined && result.confirm && result.confirm == "yes") {
              this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
              this.appBaseService
                .deleteResource(OPD_API_URL.DELETE_IDENTIFICATION+this.patientId+"&identifierUUID="+element.identifierUUID)
                .subscribe((res) => {
                  if(res.statusCode="200"){
                    this.snackBar.open(res.message,"Success",{duration:2000});
                  if (index !== 0) {
                    const data = this.identificationList.data;
                    data.splice(index, 1);
                    this.identificationList.data = [...data];
                  }
                }
                });
            }
          })
        );
      }else{
      if (index !== 0) {
        const data = this.identificationList.data;
        data.splice(index, 1);
        this.identificationList.data = [...data];
      }
    }
    }
    copyPrimaryId(element: any, index: number): void {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "Do you want to copy the primary identification?" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          
      if(element.idType && element.idNumber){
      const original = this.selectedPatientIdentificationList.find(
        (item) => item.type === 'P' && !item.isCopied 
      );
    
      if (original) {
        const copiedElement = { ...original };
        copiedElement.isCopied = true;
        copiedElement.status = false;
        this.selectedPatientIdentificationList.push(copiedElement);
        original.idType = '';
        original.idNumber = '';
        original.expDate = '';
        original.issuingCountry = '';
        original.identifierUUID=undefined;
        original.isExpiryRequired=false;
        original.isCountryRequired=false;
        original.isCopied=false;
        this.primaryIdentifierListModified = true;
        this.identificationList.data = this.selectedPatientIdentificationList;
      }
      }
      this.addEmptyIdentificationEntry("S");
          this.secondaryIdentifierListModified = true;
        }
      })
    );
    }
    addEmptyIdentificationEntry(type: 'P' | 'S'): void {
      this.identificationList.data.push({
        type: type,
        idType: '',
        idNumber: '',
        expDate: '',
        issuingCountry: '',
        maxIdentificationLength: 25,
        minIdentificationLength: 0,
        primaryIdRegex: OPD_CONST.primaryIdRegix,
        isIdNumberValid:true
      });
    
      this.identificationList.data = [...this.identificationList.data];
    }
    
}
